module.exports = __webpack_public_path__ + "static/ImageAgileTeam-b8ef906894f0e076aabf4361a79c205b.png";